import { IntegrationSyncStatus } from '@shared/enums';

export const FriendlySyncStatus = {
  [IntegrationSyncStatus.Failed]: 'Failed',
  [IntegrationSyncStatus.Pending]: 'Pending',
  [IntegrationSyncStatus.Success]: 'Success',
  [IntegrationSyncStatus.SuccessWithWarnings]: 'Success with warnings',
  [IntegrationSyncStatus.Syncing]: 'Syncing',
  [IntegrationSyncStatus.Timeout]: 'Timed out',
};
